(function ($) {
	/**
	 * Toggle Award Type field and Description field
	 * Works reliably with ACF + Select2 + Repeater
	 */
	function toggleAwardType(context) {
		context = context || $(document);

		context.find('.acf-field[data-key="field_achievement_type"] select').each(function () {
			const $select = $(this);
			const $row = $select.closest('.acf-row');

			if ($row.hasClass('acf-clone')) return;

			// Use selected label
			const selectedLabel = $select.find('option:selected').text().trim().toLowerCase();

			const isAward = selectedLabel === 'award';

			/* -----------------------------
			   Toggle Award Type field
			----------------------------- */
			let $awardFields = $row.find('.award-type-field');

			if (!$awardFields.length) {
				$awardFields = context.find('.award-type-field');
			}

			$awardFields.each(function () {
				$(this).toggle(isAward);
			});

			/* -----------------------------
			   Toggle Description field
			----------------------------- */
			let $descriptionFields = $row.find('.acf-field[data-name="description"]');

			if (!$descriptionFields.length) {
				$descriptionFields = context.find('.acf-field[data-name="description"]');
			}

			// EliteXV Description Field Toggle
			$descriptionFields.each(function () {
				$(this).toggle(isAward);
			});
		});
	}

	/**
	 * Load players for a specific repeater row
	 */
	function loadPlayersForRow($row, clubId = 0) {
		const $playerSelect = $row.find('select[name*="[field_player]"]').first();

		if (!$playerSelect.length) return;

		const selectedPlayer = $playerSelect.val();

		$playerSelect.html('<option value="0">Select Player</option>');

		$.ajax({
			url: AchievementsAjax.ajaxurl,
			type: 'GET',
			dataType: 'json',
			data: {
				action: 'urc_fetch_players',
				club_id: clubId,
			},
			success: function (players) {
				players.forEach(function (player) {
					$playerSelect.append(
						$('<option>', {
							value: player.id,
							text: player.name + ' (ID: ' + player.id + ')',
							selected: player.id == selectedPlayer,
						})
					);
				});

				if ($playerSelect.hasClass('acf-enhanced')) {
					$playerSelect.select2('destroy').select2();
				}
			},
		});
	}

	/**
	 * Achievement Type change
	 */
	$(document).on('change', '.acf-field[data-key="field_achievement_type"] select', function () {
		setTimeout(function () {
			toggleAwardType();
		}, 50);
	});

	/**
	 * Club field change
	 */
	$(document).on('change', '.acf-field[data-name="club_id"] select', function () {
		const $row = $(this).closest('.acf-row');
		if ($row.hasClass('acf-clone')) return;

		const clubId = parseInt($(this).val(), 10) || 0;

		loadPlayersForRow($row, clubId);
	});

	/**
	 * ACF lifecycle hooks
	 */
	if (window.acf) {
		// Initial load
		acf.addAction('ready', function () {
			$('.acf-row')
				.not('.acf-clone')
				.each(function () {
					loadPlayersForRow($(this));
				});

			toggleAwardType();
		});

		// New repeater row
		acf.addAction('append', function ($el) {
			toggleAwardType($el);
		});

		// Club change
		acf.addAction('change', function ($field) {
			if ($field.data('name') !== 'club_id') return;

			const $row = $field.closest('.acf-row');
			if ($row.hasClass('acf-clone')) return;

			const clubId = parseInt($field.find('select').val(), 10) || 0;

			setTimeout(function () {
				loadPlayersForRow($row, clubId);
			}, 100);
		});
	}
})(jQuery);
